<template>
    <div>
        <highcharts
            v-if="loaded"
            :options="getOptions(chartOptions)"
            ref="chart"
        />

        <div v-else class="d-flex justify-content-center">
            <b-spinner :style="{'color':constants.spinnerColor}"></b-spinner>
        </div>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import exportingInit from "highcharts/modules/exporting"
    import Highcharts from "highcharts"
    import dashboardChartMixin from '@/mixins/dashboardChartMixin'

    typeof exportingInit === 'function' && exportingInit(Highcharts);

    export default {
        name: 'StartupsCategoryChart',
        mixins: [dashboardChartMixin],
        components: {
            highcharts: Chart
        },
        data() {
            return {
                loaded: false,
                chartName: "StartupsByCategory",
                chartData: [],
                chartOptions: {
                    chart: {
                        type: "bar",
                        style: {
                            fontFamily: '"Overpass", sans-serif;',
                        },
                    },
                    title: {
                        text: this.$store.getters.isDaikinEnterprise ? "Sectors Distribution" : "Startups By Category"
                    },
                    xAxis: {
                        categories: [],
                        title: {
                            text: null
                        }
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: "Number of startups",
                            align: "high"
                        },
                        labels: {
                            overflow: "justify"
                        }
                    },
                    tooltip: {
                        valueSuffix: " startup(s)"
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true
                            },
                            events: {
                                click: (e) => {
                                    this.openStartupsModal(e.point.category)
                                }
                            }
                        }
                    },
                    series: [
                        {
                            name: "Category",
                            data: [],
                            color: '#0083b2'
                        }
                    ]
                }
            }
        },
        methods: {
            fetchChartData(initialCall = false) {
                this.getChartData('StartupsByCategory').then(response => {
                    this.chartData = response.data;
                    this.chartOptions.title.text = this.formatTitle(this.chartOptions.title.text);
                    this.formatAndSetChartData()

                    if (!initialCall) {
                        this.$refs.chart.chart.hideLoading()
                    } else {
                        this.loaded = true
                    }
                })
            },

            formatAndSetChartData() {
                let categories = []
                let startupsCount = []

                this.chartData.forEach(item => {
                    categories.push(item.category)
                    startupsCount.push(item.cnt)
                })

                this.chartOptions.xAxis.categories = categories
                this.chartOptions.series[0].data = startupsCount

                // this.$refs.chart.chart.series[0].setData(startupsCount, true)
                // this.$refs.chart.chart.xAxis[0].setCategories(categories, true)
                // this.$refs.chart.chart.redraw()
            },

            openStartupsModal(category) {
                this.$emit('showStartups', [this.chartName, this.formatTitle(`Startups in category "${category}"`), category])
            },
        }
    }
</script>
